"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
const TeamHero = t0 => {
  const $ = _c(20);
  const {
    title,
    subtitle,
    description
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 opacity-20 pointer-events-none"><div className="absolute top-0 right-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-[#C9A84C]/20 blur-[80px] sm:blur-[120px] rounded-full -translate-y-1/2 translate-x-1/2" /><div className="absolute bottom-0 left-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-[#DF6D2A]/10 blur-[80px] sm:blur-[120px] rounded-full translate-y-1/2 -translate-x-1/2" /></div>;
    t2 = <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 30
    };
    t4 = {
      opacity: 1,
      y: 0
    };
    t5 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== subtitle) {
    t6 = <span className="font-body text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.3em] uppercase text-[#C9A84C] font-medium mb-4 sm:mb-6 block">{subtitle}</span>;
    $[5] = subtitle;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== title) {
    t7 = title.split(" ").map(_temp);
    $[7] = title;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <h1 className="font-display text-[36px] sm:text-[60px] md:text-[85px] leading-[1.1] sm:leading-[1] text-[#F4EFE6] font-light mb-6 sm:mb-8 max-w-4xl mx-auto">{t7}</h1>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== description) {
    t9 = <p className="font-body text-[15px] md:text-[18px] text-white/60 leading-relaxed max-w-2xl mx-auto font-light">{description}</p>;
    $[11] = description;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t8 || $[15] !== t9) {
    t10 = <motion.div initial={t3} animate={t4} transition={t5}>{t6}{t8}{t9}</motion.div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <motion.div className="mt-16 w-px h-24 bg-gradient-to-b from-[#C9A84C] to-transparent mx-auto opacity-40" initial={{
      scaleY: 0
    }} animate={{
      scaleY: 1
    }} transition={{
      delay: 0.5,
      duration: 1
    }} />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = <section className="relative pt-24 pb-16 sm:pt-32 sm:pb-20 md:pt-48 md:pb-32 overflow-hidden bg-[#0F1C2E]">{t1}{t2}<div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8 relative z-10 text-center">{t10}{t11}</div></section>;
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
export default TeamHero;
function _temp(word, i) {
  return <span key={i} className={i % 2 === 1 ? "italic text-[#C9A84C]" : ""}>{word}{" "}</span>;
}